import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';

const TPlatformMetricsRequestQuerySchema = z.object({
  startDate: z.string(),
  endDate: z.string(),
});

export type TPlatformMetricsRequestQuery = z.infer<
  typeof TPlatformMetricsRequestQuerySchema
>;

const PlatformReportingSchemaResponse = z.object({
  totalLogins: z.number(),
  averageLogins: z.number(),
  peakDay: z.number(),
  companyTrainAIData: z
    .object({
      name: z.string(),
      totalNumber: z.number().nullable(),
    })
    .array(),
  trainAIMetrics: z.object({
    total: z.number(),
    average: z.number(),
    best: z.object({
      name: z.string(),
      totalNumber: z.number().nullable(),
    }),
  }),
  totalUserOver30Days: z.number(),
  newUsersOver30Days: z.number(),
  inactiveUsersOver30Days: z.number(),
});

export type TPlatformReportingResponse = z.infer<
  typeof PlatformReportingSchemaResponse
>;

export const reportingContract = createRESTContract({
  getPlatformMetrics: {
    method: 'GET',
    path: '/metrics/platform-user-metrics',
    permissions: [PERMISSIONS.REPORTING.REPORTING_PLATFORM_METRICS_VIEW],
    response: PlatformReportingSchemaResponse,
    query: TPlatformMetricsRequestQuerySchema,
  },
});
